


























































































import Vue from "vue";
import { createInquiry } from "@/api/Inquiry";
import SideBar from "@/parts/about/SideBar.vue";
import VariableInput from "@/components/util/VariableInput.vue";
import SelectBox from "@/components/util/SelectBox.vue";
import { mailAddressConstraintErrorMessage, mailAddressLengthLimit, mailAddressRegExp } from "./forms/constraint";
import axios from "axios";
import { ErrorResponse } from "../api/dto/Error";

type InquiryFormData = {
  category: {
    value: number;
  };
  name: {
    value: string;
    error: string;
  };
  mail: {
    value: string;
    error: string;
  };
  content: {
    value: string;
    error: string;
  };
};

// 初期値
const initialFormData: InquiryFormData = {
  category: {
    value: 1,
  },
  name: {
    value: "",
    error: "",
  },
  mail: {
    value: "",
    error: "",
  },
  content: {
    value: "",
    error: "",
  },
} as const;

export default Vue.extend({
  name: "Contact",
  components: {
    SideBar,
    VariableInput,
    SelectBox,
  },
  data() {
    const categories = [
      { value: 1, text: "システムについて" },
      { value: 2, text: "取引について" },
      { value: 3, text: "売上について" },
      { value: 4, text: "アカウントについて" },
      { value: 5, text: "法人利用について" },
      { value: 9, text: "その他" }
    ];
    return {
      // NOTE: initialFormData の代入で何故か initialFormData の値が入力値に置き換わるため、ここでは使用しない
      formData: {
        category: {
          value: 1,
        },
        name: {
          value: "",
          error: "",
        },
        mail: {
          value: "",
          error: "",
        },
        content: {
          value: "",
          error: "",
        },
      },
      categories,
      submitModal: false,
      disabled: true,
      /** 送信中かどうか */
      submitting: false,
    };
  },
  watch: {
    formData: {
      /** 「送信ボタン」活性制御 */
      handler({ name, mail, content }) {
        // 以下の項目が1つでも未入力の場合、非活性
        const isEmpty = [name.value, mail.value, content.value].some((value) => !value.trim());
        if (isEmpty) {
          this.disabled = true;
          return;
        }

        // バリデーションエラーがあれば非活性
        const validationError = [name.error, mail.error, content.error].some((error) => !!error);
        if (validationError) {
          this.disabled = true;
          return;
        }
        this.disabled = false;
      },
      deep: true,
    },
    /** 名前のバリデーション */
    "formData.name.value"(name: string) {
      if (this.submitting) {
        this.formData.name.error = "";
        return;
      }
      this.formData.name.error = !name.trim() ? "お名前を入力してください" : "";
      this.formData.name.error = name.length > 20 ? "お名前は20文字以内で入力してください" : "";
    },
    /** メールアドレスのバリデーション */
    "formData.mail.value"(mail: string) {
      if (this.submitting) {
        this.formData.mail.error = "";
        return;
      }
      this.formData.mail.error =
        !mail.trim() || !(mail.length <= mailAddressLengthLimit && mailAddressRegExp.test(mail))
          ? mailAddressConstraintErrorMessage
          : "";
    },
    /** お問い合わせ内容のバリデーション */
    "formData.content.value"(name: string) {
      if (this.submitting) {
        this.formData.content.error = "";
        return;
      }
      this.formData.content.error = !name.trim() ? "お問い合わせ内容を入力してください" : "";
    },
  },
  methods: {
    changeCat(newCategory: number) {
      this.formData.category.value = newCategory;
    },
    /**
     * お問い合わせを送信してモーダルを表示
     */
    async submit() {
      if (this.disabled) {
        return;
      }
      this.submitting = true;
      try {
        await createInquiry({
          category: `${this.formData.category.value}`,
          name: this.formData.name.value,
          mailAddress: this.formData.mail.value,
          text: this.formData.content.value,
        });
      } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
              var resError = error.response.data as ErrorResponse;
              if (resError.message != null) {
                this.$emit('errorToast', resError.message);
              }
            }
        return;
      } finally {
        setTimeout(() => {
          this.submitting = false;
        }, 0);
      }
      this.submitModal = true;
    },
    onPushPath(path: string) {
      this.$router.push(path, () => {}); // eslint-disable-line
      this.$emit("pushPath", path);
    },
    init() {
      this.formData =  {
        category: {
          value: 1,
        },
        name: {
          value: "",
          error: "",
        },
        mail: {
          value: "",
          error: "",
        },
        content: {
          value: "",
          error: "",
        },
      },
      this.submitModal = false
    },
  },
});
